import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-718e6b32"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "uikit_picture" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'uikit_molecules_picture_default',
    props: ['d'],
    setup(__props) {
        const props = __props;
        function image() {
            return {
                image_carousel_images: [
                    {
                        image: props.d.image,
                        alt: props.d.title
                    }
                ],
                width: 'full-width'
            };
        }
        return (_ctx, _cache) => {
            const _component_image_carousel = _resolveComponent("image-carousel");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_image_carousel, {
                    d: image()
                }, null, 8, ["d"])
            ]));
        };
    }
});
